

$("#DivisionNavigationContainer #select-metro").click(function () {
    $("#DivisionNavigationContainer #division-metro-list").toggle();
});



$("#DivisionNavigationContainer #close-metro-list").click(function () {
    $("#DivisionNavigationContainer #division-metro-list").toggle();
});

